import React from 'react'

export default () => (
  <svg viewBox="0 0 14 14">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.1.768a.1.1 0 0 0-.1-.1H2a1.1 1.1 0 0 0-1.1 1.1v8.667a1.1 1.1 0 0 0 1.1 1.1h5a.1.1 0 0 0 .1-.1v-.667a.1.1 0 0 0-.1-.1H2a.233.233 0 0 1-.233-.233V1.768c0-.129.104-.233.233-.233h5a.1.1 0 0 0 .1-.1V.768ZM5.667 6.635a.1.1 0 0 0 .1.1h5.958L9.83 8.63a.1.1 0 0 0 0 .141l.467.467a.1.1 0 0 0 .141 0l2.867-2.867a.1.1 0 0 0 0-.141l-2.867-2.867a.1.1 0 0 0-.141 0l-.467.467a.1.1 0 0 0 0 .14l1.835 1.897H5.767a.1.1 0 0 0-.1.1v.667Z" />
  </svg>
)
